"use client"

import { FaFacebookF, FaLinkedinIn, FaInstagram, FaTiktok } from "react-icons/fa"
import { FaX } from "react-icons/fa6"

export default function MiniFooter() {
  const currentYear = new Date().getFullYear()

  const BRAND = {
    primary: "#3B82F6",
    primaryDark: "#2563EB",
    primarySoft: "#EFF6FF",
    border: "#DBEAFE",
    text: "#1F2937",
    muted: "#6B7280",
  }

  const socialStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "36px",
    height: "36px",
    borderRadius: "8px",
    color: BRAND.primary,
    backgroundColor: "#ffffff",
    border: `1px solid ${BRAND.border}`,
    transition: "all 0.25s ease",
    textDecoration: "none",
  }

  return (
    <footer
      style={{
        background: "#ffffff",
        borderTop: `1px solid ${BRAND.border}`,
        padding: "1rem 0",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 1rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "1rem",
        }}
      >
        {/* LEFT TEXT */}
        <div
          style={{
            fontSize: "0.875rem",
            color: BRAND.muted,
            fontWeight: 500,
            textAlign: "center",
            lineHeight: 1.4,
          }}
        >
          © 2020 – {currentYear}{" "}
          <span style={{ fontWeight: 700, color: BRAND.primary }}>· u2lr</span> Link Shortener · All rights
          reserved. | <i>Developed by TegaFate HuB</i>
        </div>

        {/* SOCIAL ICONS */}
        <div
          style={{
            display: "flex",
            gap: "0.5rem",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <a
            href="https://www.facebook.com/profile.php?id=61587010800185"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            title="Facebook"
            style={socialStyle}
          >
            <FaFacebookF size={14} />
          </a>

          <a
            href="https://x.com/u2lrlinks"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X"
            title="X"
            style={socialStyle}
          >
            <FaX size={14} />
          </a>

          <a
            href="https://www.linkedin.com/in/u2lrlink-shortener-008b943a7"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            title="LinkedIn"
            style={socialStyle}
          >
            <FaLinkedinIn size={14} />
          </a>

          <a
            href="https://www.instagram.com/u2lrlinks?igsh=eDZ2am1uc3ZzZm53&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            title="Instagram"
            style={socialStyle}
          >
            <FaInstagram size={14} />
          </a>

          <a
            href="https://www.tiktok.com/@u2lrshortener?is_from_webapp=1&sender_device=pc"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Tiktok"
            title="Tiktok"
            style={socialStyle}
          >
            <FaTiktok size={14} />
          </a>
        </div>
      </div>

      {/* Hover effects */}
      <style>{`
        a:hover {
          transform: translateY(-2px);
          background: ${BRAND.primary} !important;
          color: #ffffff !important;
          border-color: ${BRAND.primary} !important;
          box-shadow: 0 6px 18px rgba(59, 130, 246, 0.35);
        }

        @media (min-width: 768px) {
          footer > div {
            flex-direction: row;
          }
          footer > div > div:first-child {
            text-align: left;
          }
        }
      `}</style>
    </footer>
  )
}
